import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-tile-border p-6 flex items-center justify-between" }
const _hoisted_2 = {
  key: 0,
  class: "w-9.5 h-px bg-neutral2-300"
}

import {computed} from "vue";
import {DrawerOption} from "./DropdownSingle.vue";
import Step, {StepMode} from "./Step.vue";

interface Props {
  steps: DrawerOption<U>[];
  step: U;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Stepper',
  props: {
    steps: {},
    step: {}
  },
  setup(__props: any) {

const props = __props;

function stepMode(index: number): StepMode {
  if (index === currentIndex.value) {
    return 'current';
  }
  if (index < currentIndex.value) {
    return 'previous';
  }
  return 'next';
}

const currentIndex = computed<number>(() => {
  return props.steps.findIndex(step => step.value === props.step);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (step, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        _createVNode(Step, {
          title: step.title,
          mode: stepMode(index),
          counter: index+1
        }, null, 8 /* PROPS */, ["title", "mode", "counter"]),
        (index < props.steps.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2))
          : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})